module.exports = __webpack_public_path__ + "img/handwritten-card.208ad8a4.png";